import React from "react";
import {isBrowser, isMobile} from 'react-device-detect';
import ARROW from "./../../../../../assets/images/chevron_down.svg";
import Accordion from 'react-bootstrap/Accordion';
import LabOrderDetail from "./LabOrderDetail";
import LabOrderItemsList from "./LabOrderItemsList";
import LabOrderActions from "./LabOrderActions";
import LabOrderItemKeyValueDetails from "./children/LabOrderItemKeyValueDetails";
const LabOrderItem = (props) => {
  const {
    id,  
    customer_contact_name,
    jalali_created_at,
    vendor_fa_status,
    customer_contact_phone,
    customer_description
  } = props.order;
  const renderLabItem = () => {
    if(isBrowser) {
      return (
        <Accordion className="bg-white shadow-sm lab-order-item-holder">
          <Accordion.Toggle  variant="link" eventKey={id}
            className="lab-order-item bg-white"
          >
            <div className="order-title">
              {customer_contact_name} {" "} - ({jalali_created_at}){" "}
              <span className="order-fa-status">{vendor_fa_status}</span>
              {" "} (کد سفارش  :  {id}) {" "}
            </div>
            <img className="expand-btn" src={ARROW} alt="arrow" width={15} />
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={id}>
            <div className="lab-order-details bg-white row">
                <div className="col-lg-7 col-md-7 col-sm-12">
                    <LabOrderDetail order={props.order} />
                    <LabOrderItemsList order={props.order} />
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 lab-order-actions-holder">
                    <div className="key-value-details">
                      { props.order.meta_data !== null && ( <LabOrderItemKeyValueDetails {...props.order} />)}
                    </div>
                    <LabOrderActions order={props.order} />
                </div>
            </div>
          </Accordion.Collapse>
        </Accordion>
      )
    } else if(isMobile) {
      return (
        <Accordion className="bg-white shadow-sm lab-order-item-holder">
          <Accordion.Toggle  variant="link" eventKey={id}
            className="lab-order-item bg-white"
          >
            <div className="order-title">
              {customer_contact_name} {" "} - ({jalali_created_at}){" "}
              <span className="order-fa-status">{vendor_fa_status}</span>
              {" "} (کد سفارش  :  {id}) {" "}
            </div>
            <div className="order-header-mobile">
              <div className="order-info-mobile">
                <p>{jalali_created_at}</p>
                <p>#{id}</p>
              </div>
              <div className="person-info-mobile">
                <p>{customer_contact_name}</p>
                <p>{customer_contact_phone}</p>
              </div>
              <div className="order-description-mobile">
                <p> توضیحات سفارش : {customer_description ?? "-"}</p>
              </div>
            </div>
            <img className="expand-btn" src={ARROW} alt="arrow" width={15} />
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={id}>
            <div className="lab-order-details bg-white row">
                <div className="col-lg-7 col-md-7 col-sm-12">
                    <LabOrderDetail order={props.order} />
                    <LabOrderItemsList order={props.order} />
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 lab-order-actions-holder">
                    <div className="key-value-details">
                      { props.order.meta_data !== null && ( <LabOrderItemKeyValueDetails {...props.order} />)}
                    </div>
                    <LabOrderActions order={props.order} />
                </div>
            </div>
          </Accordion.Collapse>
        </Accordion>
      )
    }
  }
  return (
    renderLabItem()
  );
};

export default LabOrderItem;
